import { useEffect } from 'react';
import { pushDataLayerVariables } from '../pages/Articles/utils';

declare global {
  interface Window {
    pageContexts?: any[];
  }
}

interface SeoProps {
  siteSection: string;
  siteSubsection?: string;
  title?: string;
  h1?: string;
  h2?: string;
  templateId?: string;
  seoName?: string;
  targetKeyword?: string;
  canonicalLink?: string;
  metaDescription?: string;
  robots?: string;
}

export function addSchema(schema: string, data: object) {
  removeSchema(schema);
  window.pageContexts.push({
    schema,
    data
  });
}

export function removeSchema(schema: string) {
  window.pageContexts = window.pageContexts || [];
  const contextIndex = window.pageContexts.findIndex(c => c.schema === schema);
  if (contextIndex > -1) {
    window.pageContexts.splice(contextIndex, 1);
  }
}

export function useSchema(schema: string, data: object | null, dependencies: any[]) {
  return useEffect(() => {
    if (!data) return;
    addSchema(schema, data);
    return () => removeSchema(schema);
  }, dependencies);
}

export function usePlatformFeature(level1: string, level2: string) {
  return useSchema(
    PLATFORM_FEATURE_SCHEMA,
    {
      pf_level_1: level1,
      pf_level_2: level2
    },
    [level1, level2]
  );
}

//hook to setup seo metrics by pushing into datalayer and setting up the schema as well
export function useSetupSeoMetrics(seoProps: SeoProps) {
  const { templateId, ...rest } = seoProps;
  const {
    siteSection,
    siteSubsection,
    title,
    h1,
    h2,
    seoName,
    targetKeyword,
    canonicalLink,
    metaDescription,
    robots
  } = rest;
  //setup datalayer variables
  useEffect(() => {
    pushDataLayerVariables(rest);
  }, []);
  const schemaData = {
    site_section: siteSection,
    site_subsection: siteSubsection,
    title: title,
    h1,
    h2,
    template_id: templateId,
    seo_name: seoName,
    target_keyword: targetKeyword,
    canonical_link: canonicalLink,
    meta_description: metaDescription,
    robots: robots
  };
  //sanitize schema data to remove empty and undefined strings
  Object.keys(schemaData).forEach(key => !schemaData[key] && delete schemaData[key]);
  //setup seo schema on page load
  useSchema('iglu:au.com.hipagesgroup.hip/seo/jsonschema/1-0-0', schemaData, []);
}

export const PLATFORM_FEATURE_SCHEMA =
  'iglu:au.com.hipagesgroup.hip/platform_feature/jsonschema/1-0-0';
